// extracted by mini-css-extract-plugin
export default {"formContainer":"eFd9oj2QatkPgIJkilys"};